import { useMutation } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';
import { DuplicateCropMutation } from '../../mutations';
import { captureEvent } from '../../utils/analytics';
import { MutateAndSetStateType } from '../../hooks/useMutateWithState';
import { getFarmPath } from '../../utils/utils';

interface DuplicateCropProps {
  id: string;
  mutateAndSetState: MutateAndSetStateType;
}

const DuplicateCrop = ({ id, mutateAndSetState }: DuplicateCropProps) => {
  const [duplicateCrop] = useMutation(DuplicateCropMutation);
  const navigate = useNavigate();
  const { farmId } = useParams();

  const onClick = () => {
    captureEvent('duplicate-crop', { id });
    mutateAndSetState<{ id: string }>(() =>
      duplicateCrop({ variables: { input: { id } } }),
    ).then((response) => {
      const cropId = response?.data?.duplicateCrop?.result?.id;
      if (cropId) {
        navigate(getFarmPath(farmId, `data/crops/${cropId}/edit`));
      }
    });
  };

  return <DropdownItem onClick={onClick}>Duplicate Crop</DropdownItem>;
};

export default DuplicateCrop;
